import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DropDown from './DropDown';
import Button from './Button';

const Wrapper = styled.div`
  width: 100%;
  padding: 80px 0;
  ${props => props.theme.bp.sm`
    padding: 60px 0;
  `}

  /* Position above the XOs */
  z-index: 2;
  position: relative;
`;

const Container = styled.div`
  ${props => props.theme.container}
  ${props => props.theme.formContainer}
  margin: 0 auto;
  text-align: center;
`;

const ConfirmationContainer = styled.div`
  ${props => props.theme.container}
  ${props => props.theme.formContainer}
  margin: 0 auto;
  text-align: center;

  padding-bottom: 50px;

  span {
    font-size: 5rem;
  }
`;

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 35px;
  grid-row-gap: 30px;

  ${props => props.theme.bp.md`
    grid-column-gap: 35px;
    grid-row-gap: 30px;
  `}
  ${props => props.theme.bp.sm`
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    grid-template-columns: 1fr;
  `}
`;

const Input = styled.input`
  background-color: ${props => props.theme.colors.inputBackground};
  color: ${props => props.theme.colors.normalText};
  font-size: 1.6rem;
  padding: 20px;
  border: none;
  ${props => props.theme.fonts.sansSerif.regular}
`;

const Textarea = styled.textarea`
  grid-column: 1/3;
  background-color: ${props => props.theme.colors.inputBackground};
  color: ${props => props.theme.colors.normalText};
  font-size: 1.6rem;
  padding: 20px;
  border: none;
  height: 270px;
  ${props => props.theme.fonts.sansSerif.regular}
  ${props => props.theme.bp.sm`
    grid-column: auto;
  `}
`;

const SubmitLink = styled.div`
  text-align: left;
  ${props => props.theme.bp.sm`
    width: 100%;
    > div {
      display: block;
    }
  `}
`;

const H2 = styled.h2`
  margin-bottom: 20px;
`;

const SubText = styled.p`
  ${props => props.theme.fonts.sansSerif.regular}
  font-size: 2.5rem;
  color: ${props => props.theme.colors.midText};
  text-align: center;
  line-height: 3.8rem;
  margin: 0 auto;
`;

function submitForm(params) {
  let url = new URL('https://us-central1-twos-complement.cloudfunctions.net/contact-form');
  url.search = new URLSearchParams(params);
  fetch(url, {
    mode: 'no-cors',
  });
}

const PROJECT_TYPES = [
  "I need help building an app",
  "I need help delivering a solution",
  "I need help experimenting / innovation",
];

const ContactForm = ({
  title,
  selectedProjectType,
}) => {

  const [projectType, setProjectType] = useState(PROJECT_TYPES[selectedProjectType]);
  const [budget, setBudget] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  return (
    /* id ContactForm used for scrollTo behavior */
    <Wrapper id="ContactForm">

      {!showConfirmation &&
        <Container>
          {title && <h2>{title}</h2>}
          <Form>
            
            {selectedProjectType === null &&
              <>
                <DropDown
                  value={projectType}
                  options={PROJECT_TYPES}
                  placeholder="Select a project type"
                  onChange={value => setProjectType(value)}
                />
                <DropDown
                  value={budget}
                  options={[
                    "less than $10,000",
                    "$10,000 - $50,000",
                    "$50,000 - $150,000",
                    "$150,000+",
                  ]}
                  placeholder="Select a budget"
                  onChange={value => setBudget(value)}
                />
              </>
            }
            <Input
              type="text"
              name="name"
              value={name}
              placeholder="Name"
              onChange={e => setName(e.target.value)}
            />
            <Input
              type="email"
              name="email"
              value={email}
              placeholder="Email Address"
              onChange={e => setEmail(e.target.value)}
            />
            <Textarea
              name="description"
              value={description}
              placeholder="Give us an idea of your project needs..."
              onChange={e => setDescription(e.target.value)}
            />
            <SubmitLink>
              <Button onClick={e => {
                e.preventDefault();
                setShowConfirmation(true);
                submitForm({
                  projectType,
                  budget,
                  name,
                  email,
                  description,
                });
              }}>Let's Chat!</Button>
            </SubmitLink>
          </Form>
        </Container>
      }

      {showConfirmation &&
        <ConfirmationContainer>
          <span role="img" aria-label="jsx-a11y/accessible-emoji">🎉</span>
          <H2>Thank you for connecting!</H2>
          <SubText>We look forward to meeting your team.</SubText>
        </ConfirmationContainer>
      }
    </Wrapper>
  );
};

ContactForm.propTypes = {
  title: PropTypes.string,
  selectedProjectType: PropTypes.number,
};

ContactForm.defaultProps = {
  title: null,
  selectedProjectType: null,
};

export default ContactForm;
